import ControlSlider from "./control-slider";
import { CONTROL_SLIDER_MARKER_PCTS } from "./slider-math";

export default function SlowControlSection({
  slowControl,
  onSlowControlChange,
}) {
  const stepLabel = slowControl === 1 ? "None" : String(slowControl);

  return (
    <div className="content__item">
      <div className="content__title">Slow Control</div>
      <ControlSlider
          label={stepLabel}
          markerPcts={CONTROL_SLIDER_MARKER_PCTS}
          min="1"
          max="1.4"
          step="0.01"
          value={2 - slowControl}
          ghostEnabled
          onChange={(event) => {
            const value = parseFloat(
              (2 - parseFloat(event.currentTarget.value)).toFixed(2),
            );
            onSlowControlChange(value);
          }}
        />
    </div>
  );
}
